import { Link } from "react-router-dom";
import { LEARNER_LICENSE_CONTACT_EMAIL } from "../../constants";

export const InviteSupportLink: React.FC<{ errorCode: string }> = ({
  errorCode,
}) => {
  const subject = encodeURIComponent(
    `License Invite Support, Error: ${errorCode}`
  );
  return (
    <Link
      className="underline underline-offset-2 hover:text-dm-brand-blue-800/80 hover:no-underline"
      to={`mailto:${LEARNER_LICENSE_CONTACT_EMAIL}&subject=${subject}`}
    >
      {LEARNER_LICENSE_CONTACT_EMAIL}
    </Link>
  );
};
